import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { partners } from "./partners";
import "swiper/css";
import "swiper/css/autoplay";
import { PartnersWrapper, SlideContent, Logo, Header } from "./styled";
import { useTranslation } from "react-i18next";

const Partners = () => {

    const { t } = useTranslation();

    return (
        <PartnersWrapper id="partners">
            <Header>{t("partners.title")}</Header>
            <Swiper
                modules={[Autoplay]}
                slidesPerView={3}
                spaceBetween={30}
                speed={4000}
                loop={true}
                freeMode={true}
                autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
                breakpoints={{
                    640: { slidesPerView: 3 },
                    768: { slidesPerView: 4 },
                    1024: { slidesPerView: 6 },
                }}
            >
                {partners.map((partner, index) => (
                    <SwiperSlide key={index}
                        style={{ overflow: "visible" }}>
                        <SlideContent
                            href={partner.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            title={t("partners.visit", { name: partner.name || "partner" })}
                            aria-label={t("partners.visit", { name: partner.name || "partner" })}
                        >
                            <Logo src={partner.logo} alt={partner.alt} />
                        </SlideContent>
                    </SwiperSlide>
                ))}
            </Swiper>
        </PartnersWrapper>
    );
};

export default Partners;